import React from 'react';
import { Drawer, Stack } from '@mui/material';
import ClientAccessErrorPanel, {
  ClientAccessErrorVariant,
} from '@/components/common/ClientAccessErrorPanel';
import FlyoutHeader from './FlyoutHeader';
import { FLYOUT_WIDTH } from '../constants';

interface FlyoutAccessErrorStateProps {
  open: boolean;
  onClose: () => void;
  variant: ClientAccessErrorVariant;
  title: string;
  subtitle: string;
  showBackAction?: boolean;
}

const FlyoutAccessErrorState: React.FC<FlyoutAccessErrorStateProps> = ({
  open,
  onClose,
  variant,
  title,
  subtitle,
  showBackAction,
}) => (
  <Drawer
    anchor='right'
    open={open}
    onClose={onClose}
    variant='temporary'
  >
    <Stack sx={{ width: FLYOUT_WIDTH }}>
      <FlyoutHeader
        title={title}
        subtitle={subtitle}
        onClose={onClose}
      />
      <ClientAccessErrorPanel
        variant={variant}
        onBack={showBackAction ? onClose : undefined}
      />
    </Stack>
  </Drawer>
);

export default FlyoutAccessErrorState;
